import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Avatar from "@material-ui/core/Avatar";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useStyles from "../../../../styles";
import { decryptData } from "../../../../crypto";
import QuestionHead from "../../../CustomComponent/QuestionHead";
import CustomTab from "../AddQuestion/TabComponent";
import CustomTabPanel from "../AddQuestion/TabPanelComponent";
import { a11yProps } from "../AddQuestion/Utils";
import QuestionList from "./ViewCenterFeedBackQuestion";
import EditSingle from "./EditCemterFeedBackQuestion";

const localStyles = makeStyles((theme) => ({
  root: {
    marginTop: "1rem",
    flexGrow: 1,
    "& .MuiAppBar-colorPrimary": {
      color: "#fff",
      backgroundColor: "#484848",
    },
    "& .MuiTab-textColorInherit.Mui-selected": {
      color: "#252525",
      backgroundColor: "#FFFFFF",
    },
  },
  tab: {
    margin: "0.5rem",
    padding: "0.7rem",
    minHeight: "auto",
    borderRadius: "6px",
    opacity: 1,
    "&:hover": {
      color: "#252525",
      backgroundColor: "#FFFFFF",
    },
  },
  deletebtn: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
  },
  custombtnblue: {
    background: "#00577B !important",
    color: "white !important",
    fontSize: "1rem !important",
    fontFamily: "Outfit !important",
    fontWeight: "600 !important",
    textTransform: "capitalize !important",
    padding: "0.4rem 2rem !important",
    margin: "10px",
    "&:hover": {
      background: "#00577B !important",
      color: "white !important",
    },
  },
}));

const modalStyle2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 410,
  backgroundColor: "white",
  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  borderRadius: "8px",
};

const defaultOptions = {
  option: "" || null,
  correct_option: false,
  description: "",
};

// --- Inline Add Single Question Component (Text Area Based) ---
function AddCenterFeedBackSingle({ changeTab, examDetails, questionsLength }) {
  const classes = useStyles();
  const { rowId } = useParams();

  const initialData = {
    questiontype: "Single",
    hardnesslevel: "medium",
    topic: "",
    marks:
      examDetails.questionMarkSystem === "same"
        ? examDetails.perQuestionMark
        : 0,
    negative_marking:
      examDetails.questionMarkSystem === "same"
        ? examDetails.negativeMarking
        : "no",
    negative_marking_score:
      examDetails.questionMarkSystem === "same"
        ? examDetails.negativeMarkingScore
        : 0,
    partial_marks: 0,
    q_prifix: questionsLength + 1,
    section: "",
  };

  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const [formDetails, setFormDetails] = useState(initialData);
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [quillContentEnglishQuestion, setQuillContentEnglishQuestion] =
    useState("");
  const [quillContentEnglishParagraph, setQuillContentEnglishParagraph] =
    useState("");
  const [quillContentEnglishSolution, setQuillContentEnglishSolution] =
    useState("");

  const [quillContentEnglishDescription, setQuillContentEnglishDescription] =
    useState("");
  const [selectedCorrectOption, setSelectedCorrectOption] = useState([]);
  const [optionsArrayEnglish, setOptionsArrayEnglish] = useState([
    { index: 0, ...defaultOptions },
    { index: 1, ...defaultOptions },
    { index: 2, ...defaultOptions },
    { index: 3, ...defaultOptions },
  ]);
  const question = "normal"; // Fixed: always normal for center feedback
  const [sections, setSections] = useState([]);

  const handleOptionClick = (alphabet, index) => {
    const newOptionsEnglish = optionsArrayEnglish.map((option, i) => ({
      ...option,
      correct_option: i === index,
    }));

    setOptionsArrayEnglish(newOptionsEnglish);
    setSelectedCorrectOption(alphabet);
  };

  const [personName, setPersonName] = useState([]);
  const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false);

  const handleLanguageDropdownOpen = () => {
    setLanguageDropdownOpen(true);
  };

  const handleLanguageDropdownClose = () => {
    setLanguageDropdownOpen(false);
  };

  const handleChangeMulti = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(typeof value === "string" ? value.split(",") : value);
    handleLanguageDropdownClose();
  };

  const [alphabetArray] = useState([
    "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M",
    "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"
  ]);

  const handleClose = () => {
    changeTab(0);
  };

  const menuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    disablePortal: true,
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const [names, setNames] = useState([]);
  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const fetchLanguages = async (rowId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/language/${rowId}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      if (response.data.success) {
        const languages = response.data.languages
          .map((lang) => capitalizeFirstLetter(lang.language))
          .filter((lang) => lang === "English");
        setNames(languages.length > 0 ? languages : ["English"]);
        setPersonName(["English"]);
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchLanguages(rowId);
  }, [rowId]);

  // useEffect(() => {
  //   const fetchSubjects = async (rowId) => {
  //     try {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/subject/by_exam/${rowId}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${decryptedToken}`,
  //           },
  //         }
  //       );

  //       setTopics(response.data.subjects);
  //     } catch (error) {
  //       console.error("API Error:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchSubjects(rowId);
  // }, [decryptedToken]);

  // useEffect(() => {
  //   const fetchSection = async (subjectId) => {
  //     if (!subjectId) return;
  //     try {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/subject_section/subject_id/${subjectId}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${decryptedToken}`,
  //           },
  //         }
  //       );

  //       setSections(response.data.subjects_section);
  //     } catch (error) {
  //       console.error("API Error:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchSection(formDetails.topic);
  // }, [formDetails.topic]);

  const handleEnglishSolutionChange = (value) => {
    setQuillContentEnglishSolution(value);
  };

  const validateFields = () => {
    if (!quillContentEnglishQuestion || !quillContentEnglishQuestion.trim()) {
      toast.error("Please enter the question");
      return false;
    }
    const hasAtLeastOneOption = optionsArrayEnglish.some(
      (opt) => opt.option && opt.option.trim()
    );
    if (!hasAtLeastOneOption) {
      toast.error("Please enter option");
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (!validateFields()) {
      return;
    }
    let updatedOptionsArray = optionsArrayEnglish.map((optionEng, index) => {
      let isCorrect = optionEng.correct_option;
      let englishSolution = quillContentEnglishSolution;

      return {
        option_en: optionEng.option || "",
        option_hi: "",
        correct_option: isCorrect,
        solution_en: englishSolution,
        solution_hi: "",
        description_en: "",
        description_hi: "",
        q_prifix: index + 1,
      };
    });

    const data = {
      data: {
        question: {
          exam_id: rowId,
          question_type: formDetails.questiontype, // Single
          hardness_level: formDetails.hardnesslevel,
          // subject_id: formDetails.topic,
          subject_id: null,
          duration: formDetails.duration,
          mark: formDetails.marks,
          negative_marking: formDetails.negative_marking,
          // negative_mark: formDetails.negative_marking_score,
          negative_mark: null,
          question_en: quillContentEnglishQuestion,
          question_hi: null,
          description_en: quillContentEnglishDescription,
          description_hi: null,
          q_prifix: formDetails.q_prifix || 0,
          type: question, // normal
          paragraph_en: quillContentEnglishParagraph,
          paragraph_hi: null,
          section_id: formDetails.section || null,
        },
        options: updatedOptionsArray,
      },
    };

    axios.post(`${process.env.REACT_APP_API_BASE_URL}/v1/b2b/question/add/center_feedback`, data, {
      headers: {
        Authorization: `Bearer ${decryptedToken}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.data)
      .then((data) => {
        if (data.success) {
          toast.success(
            "Question created successfully, navigating to Question List Page"
          );
          setTimeout(() => {
            changeTab(0);
          }, 2000);
        } else {
          toast.error(data.message || "Failed to create Question");
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        toast.error(error.toString());
      });
  };



  return (
    <>
      <div
        className={`${classes.mt1} ${classes.inputpadding} ${classes.inputborder} ${classes.pagescroll} ${classes.h60vh}`}
      >
        <FormControl className={`${classes.w100}`}>
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
          >
            {/* <div className={`${classes.dflex} ${classes.justifyspacebetween}`}>
                <Typography
                  className={`${classes.w24} ${classes.mb1} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                >
                  *Create Question
                </Typography>
              
                <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}>
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    Question Type
                  </FormLabel>

                  <Select
                    labelId="category-label"
                    id="state"
                    value={formDetails.questiontype}
                    name="questiontype"
                    onChange={handleChange}
                    displayEmpty
                    className={classes.selectEmpty}
                    MenuProps={menuProps}
                    variant="outlined"
                    disabled={question === "typing"}
                  >
                    <MenuItem disabled value="">
                      <em className={classes.defaultselect}>Question Type</em>
                    </MenuItem>
                    <MenuItem value={"Single"}>Single</MenuItem>
                    
                  </Select>
                </div>
                <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.mb1}`}>
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    Hardness Level
                  </FormLabel>

                  <Select
                    labelId="category-label"
                    id="state"
                    value={formDetails.hardnesslevel}
                    name="hardnesslevel"
                    onChange={handleChange}
                    displayEmpty
                    className={classes.selectEmpty}
                    MenuProps={menuProps}
                    variant="outlined"
                  >
                    <MenuItem disabled value="">
                      <em className={classes.defaultselect}>Select Here</em>
                    </MenuItem>
                    <MenuItem value={"easy"}>Easy</MenuItem>
                    <MenuItem value={"medium"}>Medium</MenuItem>
                    <MenuItem value={"hard"}>Hard</MenuItem>
                    <MenuItem value={"expert"}>Expert</MenuItem>
                  </Select>
                </div>
              </div> */}

            {/* <div className={`${classes.dflex} ${classes.justifyspacebetween}`}>
                <Typography
                  className={`${classes.w24} ${classes.mb1} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                ></Typography>
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn} ${
                    question === "typing"
                      ? examDetails.examTemplate === "ssc/railway" ||
                        examDetails.examTemplate === "ipmat"
                        ? classes.w37
                        : classes.w100
                      : classes.w24
                  } ${
                    question === "typing" &&
                    (examDetails.examTemplate !== "ssc/railway" ||
                      examDetails.examTemplate !== "ipmat") &&
                    classes.ml4
                  } ${classes.mb1}`}
                >
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    Subject
                  </FormLabel>
                  <Select
                    labelId="demo-simple-select-placeholder-label-label"
                    id="demo-simple-select-placeholder-label"
                    value={formDetails.topic}
                    name="topic"
                    onChange={handleChange}
                    displayEmpty
                    className={classes.selectEmpty}
                    MenuProps={menuProps}
                    variant="outlined"
                  >
                    <MenuItem disabled value="">
                      <em className={classes.defaultselect}>Select Subject</em>
                    </MenuItem>
                    {loading ? (
                      <MenuItem disabled value="">
                        Loading Subjects...
                      </MenuItem>
                    ) : (
                      topics.map((topic) => (
                        <MenuItem key={topic.id} value={topic.id}>
                          {topic.subject_name}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </div>
                <>
                  {examDetails.examTemplate === "ssc/railway" ||
                  examDetails.examTemplate === "ipmat" ? (
                    <div
                      className={`${classes.dflex} ${
                        classes.flexdirectioncolumn
                      } ${question === "typing" ? classes.w37 : classes.w24} ${
                        classes.mb1
                      }`}
                    >
                      <FormLabel
                        className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                      >
                        Sections
                      </FormLabel>

                      <Select
                        labelId="demo-simple-select-placeholder-label-label"
                        id="demo-simple-select-placeholder-label"
                        value={formDetails.section}
                        name="section"
                        onChange={handleChange}
                        displayEmpty
                        className={classes.selectEmpty}
                        MenuProps={menuProps}
                        variant="outlined"
                      >
                        <MenuItem disabled value="">
                          <em className={classes.defaultselect}>
                            Select Section
                          </em>
                        </MenuItem>
                        {sections.map((section) => (
                          <MenuItem key={section.id} value={section.id}>
                            {section.section_name}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  ) : (
                    question !== "typing" && (
                      <div
                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.mb1}`}
                      >
                        <FormLabel
                          className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                        >
                          Language
                        </FormLabel>
                        <Select
                          labelId="demo-multiple-checkbox-label"
                          id="demo-multiple-checkbox"
                          multiple
                          disabled
                          value={personName}
                          onChange={handleChangeMulti}
                          open={languageDropdownOpen}
                          onOpen={handleLanguageDropdownOpen}
                          onClose={handleLanguageDropdownClose}
                          variant="outlined"
                          renderValue={(selected) => selected.join(", ")}
                          MenuProps={menuProps}
                        >
                          {names.map((name) => (
                            <MenuItem key={name} value={name}>
                              <Checkbox
                                checked={personName.indexOf(name) > -1}
                              />
                              <ListItemText primary={name} />
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    )
                  )}
                  {examDetails.examTemplate !== "ssc/railway" ||
                  examDetails.examTemplate !== "ipmat" ? (
                    <div
                      className={`${classes.dflex} ${
                        classes.flexdirectioncolumn
                      } ${
                        question === "typing"
                          ? examDetails.examTemplate === "ssc/railway" ||
                            examDetails.examTemplate === "ipmat"
                            ? classes.w37
                            : classes.w0
                          : classes.w24
                      } ${classes.mb1}`}
                    ></div>
                  ) : (
                    question !== "typing" && (
                      <div
                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.mb1}`}
                      >
                        <FormLabel
                          className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                        >
                          Language
                        </FormLabel>
                        <Select
                          labelId="demo-multiple-checkbox-label"
                          id="demo-multiple-checkbox"
                          multiple
                          disabled
                          value={personName}
                          onChange={handleChangeMulti}
                          open={languageDropdownOpen}
                          onOpen={handleLanguageDropdownOpen}
                          onClose={handleLanguageDropdownClose}
                          variant="outlined"
                          renderValue={(selected) => selected.join(", ")}
                          MenuProps={menuProps}
                        >
                          {names.map((name) => (
                            <MenuItem key={name} value={name}>
                              <Checkbox
                                checked={personName.indexOf(name) > -1}
                              />
                              <ListItemText primary={name} />
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    )
                  )}
                </>
              </div> */}

            {/* <div className={`${classes.dflex} ${classes.justifyspacebetween}`}>
                <Typography
                  className={`${classes.w24} ${classes.mb1} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                ></Typography>

                {question !== "typing" && (
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.mb1}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Question Number
                    </FormLabel>
                    <TextField
                      type="number"
                      variant="outlined"
                      name="q_prifix"
                      onChange={handleChange}
                      value={formDetails.q_prifix}
                      placeholder="Type Here"
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>
                )}
                {examDetails.questionMarkSystem === "same" ? (
                  <div
                    className={`${classes.dflex} ${
                      classes.flexdirectioncolumn
                    } ${question === "typing" ? classes.w100 : classes.w24} ${
                      question === "typing" && classes.ml4
                    } ${classes.mb1}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Marks
                    </FormLabel>
                    <TextField
                      type="number"
                      variant="outlined"
                      name="marks"
                      onChange={handleChange}
                      value={formDetails.marks}
                      placeholder="Type Here"
                      disabled
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>
                ) : (
                  <div
                    className={`${classes.dflex} ${
                      classes.flexdirectioncolumn
                    } ${question === "typing" ? classes.w100 : classes.w24} ${
                      question === "typing" && classes.ml4
                    } ${classes.mb1}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Marks
                    </FormLabel>
                    <TextField
                      type="number"
                      variant="outlined"
                      name="marks"
                      onChange={handleChange}
                      value={formDetails.marks}
                      placeholder="Type Here"
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>
                )}
                {question !== "typing" && (
                  <>
                    {examDetails.questionMarkSystem === "same" ? (
                      <div
                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.mb1}`}
                      >
                        <FormLabel
                          className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                        >
                          Negative Marking{" "}
                        </FormLabel>
                        <Select
                          labelId="negativemarking-label"
                          id="negativemarking"
                          value={formDetails.negative_marking}
                          name="negative_marking"
                          onChange={handleChange}
                          displayEmpty
                          className={classes.selectEmpty}
                          MenuProps={menuProps}
                          variant="outlined"
                          disabled
                        >
                          <MenuItem disabled value="">
                            <em className={classes.defaultselect}>
                              Select Here
                            </em>
                          </MenuItem>
                          <MenuItem value={"yes"}>Yes</MenuItem>
                          <MenuItem value={"no"}>No</MenuItem>
                        </Select>
                      </div>
                    ) : (
                      <div
                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.mb1}`}
                      >
                        <FormLabel
                          className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                        >
                          Negative Marking{" "}
                        </FormLabel>
                        <Select
                          labelId="negativemarking-label"
                          id="negativemarking"
                          value={formDetails.negative_marking}
                          name="negative_marking"
                          onChange={handleChange}
                          displayEmpty
                          className={classes.selectEmpty}
                          MenuProps={menuProps}
                          variant="outlined"
                        >
                          <MenuItem disabled value="">
                            <em className={classes.defaultselect}>
                              Select Here
                            </em>
                          </MenuItem>
                          <MenuItem value={"yes"}>Yes</MenuItem>
                          <MenuItem value={"no"}>No</MenuItem>
                        </Select>
                      </div>
                    )}
                  </>
                )}
              </div> */}

            {/* <div className={`${classes.dflex} ${classes.justifyspacebetween}`}>
                <Typography
                  className={`${classes.w24} ${classes.mb1} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                ></Typography>
                {question !== "typing" && (
                  <>
                    {examDetails.questionMarkSystem === "same" ? (
                      <div
                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.mb1}`}
                      >
                        <FormLabel
                          className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                        >
                          Negative Marking Score{" "}
                        </FormLabel>
                        <TextField
                          type="float"
                          variant="outlined"
                          required
                          name="negative_marking_score"
                          value={formDetails.negative_marking_score}
                          onChange={handleChange}
                          placeholder="Type Here"
                          disabled
                        />
                      </div>
                    ) : (
                      <div
                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.mb1}`}
                      >
                        <FormLabel
                          className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                        >
                          Negative Marking Score{" "}
                        </FormLabel>
                        <TextField
                          type="float"
                          variant="outlined"
                          required
                          name="negative_marking_score"
                          value={
                            formDetails.negative_marking === "yes"
                              ? `-${String(
                                formDetails.negative_marking_score
                              ).replace(/^[-]+/, "")}`
                              : formDetails.negative_marking_score
                          }
                          onChange={(e) => {
                            let value = e.target.value.replace(/[^0-9.]/g, "");

                            if (formDetails.negative_marking === "yes") {
                              value = value ? `-${value}` : "";
                            }

                            handleChange({
                              target: {
                                name: "negative_marking_score",
                                value,
                              },
                            });
                          }}
                          placeholder="Type Here"
                          disabled={formDetails.negative_marking === "no"}
                        />
                      </div>
                    )}
                  </>
                )}
                {formDetails.questiontype === "Multiple Choice" ? (
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.mb1}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Partial Marking{" "}
                    </FormLabel>
                    <TextField
                      type="number"
                      variant="outlined"
                      name="partial_marks"
                      onChange={handleChange}
                      value={formDetails.partial_marks}
                      placeholder="Type Here"
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>
                ) : (
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.mb1}`}
                  ></div>
                )}
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.mb1}`}
                ></div>
              </div> */}

            <div className={classes.mt1}>
              <Typography className={classes.centeredTitle} variant="h6">
                English
              </Typography>
              <div className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}>
                <Typography
                  className={`${classes.w24} ${classes.mb1} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                >
                  {question === "normal" && "*Enter Question"}
                </Typography>

                <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w75}`}>
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    Enter Your Question
                  </FormLabel>
                  <TextField
                    multiline
                    minRows={4}
                    placeholder="Enter your question"
                    variant="outlined"
                    fullWidth
                    className={`${classes.dflex} ${classes.flexdirectioncolumn}`}
                    value={quillContentEnglishQuestion}
                    onChange={(e) => {
                      setQuillContentEnglishQuestion(e.target.value);
                    }}
                  />
                </div>
              </div>

              <div className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}>
                <Typography
                  className={`${classes.w24} ${classes.mb1} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                >
                  *Options
                </Typography>
                <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w75}`}>
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    Enter Your Options
                  </FormLabel>

                  {optionsArrayEnglish.map(
                    (optionEng, optionIndex) => {
                      return (
                        <div
                          key={optionIndex}
                          className={`${classes.input2} ${classes.optionContainer}`}
                        >
                          <div
                            className={classes.opt}
                            onClick={() =>
                              handleOptionClick(
                                alphabetArray[optionIndex],
                                optionIndex
                              )
                            }
                          >
                            {/* <Avatar
                                className={
                                  optionEng.correct_option
                                    ? classes.avtar_active
                                    : classes.avtar
                                }
                              >
                                {alphabetArray[optionIndex]}
                              </Avatar> */}
                          </div>
                          <TextField
                            multiline
                            minRows={2}
                            variant="outlined"
                            fullWidth
                            placeholder="Enter your option"
                            value={optionEng.option || ""}
                            onChange={(e) => {
                              const val = e.target.value;
                              const newOptionsEnglish = [
                                ...optionsArrayEnglish,
                              ];

                              newOptionsEnglish[
                                optionIndex
                              ].option = val;

                              setOptionsArrayEnglish(
                                newOptionsEnglish
                              );
                            }}
                          />
                        </div>
                      );
                    }
                  )}
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "3rem",
                }}
              >
                <Button
                  className={classes.addmorebtn}
                  onClick={() => {
                    optionsArrayEnglish.push({
                      index: optionsArrayEnglish.length,
                      ...defaultOptions,
                    });
                    setOptionsArrayEnglish([
                      ...optionsArrayEnglish,
                    ]);
                  }}
                >
                  Add More
                </Button>
                <Button
                  style={{ marginLeft: "1rem" }}
                  className={classes.removebtn}
                  onClick={() => {
                    if (optionsArrayEnglish.length > 1) {
                      const lastOption =
                        optionsArrayEnglish[
                        optionsArrayEnglish.length - 1
                        ];

                      if (lastOption.correct_option) {
                        toast.error(
                          "Cannot remove the last option as it is the correct answer"
                        );
                      } else {
                        optionsArrayEnglish.pop();
                        setOptionsArrayEnglish([
                          ...optionsArrayEnglish,
                        ]);
                      }
                    } else {
                      toast.error(
                        "Cannot remove the last option as it is the only option"
                      );
                    }
                  }}
                >
                  Remove
                </Button>
              </div>

              {/* Description section removed for center feedback questions */}
            </div>
          </div >

          <div className={`${classes.dflex} ${classes.justifyflexend} ${classes.mt1}`}>
            <Button
              className={`${classes.custombtnoutline}`}
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              className={`${classes.custombtnblue}`}
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </div>
        </FormControl>
      </div>
    </>
  );
}

// --- Main Container Page for Center Feedback Questions ---
function AddCenterFeedBackQuestionMain() {
  const classes = useStyles();
  const classesLocal = localStyles();
  const { rowId } = useParams();
  const location = useLocation();
  const mainExamId = location.state?.mainExamId || rowId;
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const [questionsCount, setQuestionsCount] = useState("");
  const [examTemplate, setExamTemplate] = useState("");
  const [examDetails, setExamDetails] = useState({
    examName: "",
    courseName: "",
    batchName: "",
    subjectNames: "",
    examImage: "",
    questionMarkSystem: "",
    perQuestionMark: "",
    negativeMarking: "",
    negativeMarkingScore: "",
  });
  const [loading, setLoading] = useState(false);

  // Tabs state
  const [value, setValue] = useState(0);
  const [editQuestion, setEditQuestion] = useState();
  const [questionsLength, setQuestionsLength] = useState();
  const [openDelete, setOpenDelete] = useState(false);
  const [IsDelete, setIsDelete] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const handleToggleShowPassword = () => setShowPassword(!showPassword);

  const buttonContainerStyle = {
    marginTop: "20px",
    display: "flex",
    justifyContent: "flex-end",
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleDelete = async () => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/bulk/question/${rowId}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      toast.success("All questions deleted successfully");
      setOpenDelete(false);
      window.location.reload();
    } catch (error) {
      toast.error("Questions is not deleted");
      console.error("Error deleting data: ", error);
    }
  };

  const handleStatus = async () => {
    if (!password) {
      toast.error("Please enter a password.");
      return;
    }

    try {
      const checkPasswordData = { user: { password } };

      const passwordCheckResponse = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/check/password`,
        checkPasswordData,
        { headers: { Authorization: `Bearer ${decryptedToken}` } }
      );

      if (!passwordCheckResponse.data.success) {
        toast.error("Invalid password. Please try again.");
        return;
      }
      handleDelete();
    } catch (error) {
      console.error("Error checking password:", error);
      toast.error("Invalid password. Please try again.");
    }
  };

  const changeTab = (tabIndex) => {
    setValue(tabIndex);
  };

  const EditchangeTab = (tabIndex, value) => {
    setValue(tabIndex);
    setEditQuestion(value);
  };

  useEffect(() => {
    const fetchExamData = async () => {
      try {
        const [examResponse, courseBatchResponse] = await Promise.all([
          axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/${rowId}`,
            {
              headers: {
                Authorization: `Bearer ${decryptedToken}`,
              },
            }
          ),
          axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/course_batch/${mainExamId}`,
            {
              headers: {
                Authorization: `Bearer ${decryptedToken}`,
              },
            }
          )
        ]);

        const exam = examResponse.data.exam;
        const courseBatchData = courseBatchResponse.data || {};

        const courses = courseBatchData.course || (courseBatchData.exam && courseBatchData.exam.course) || (courseBatchData.data && courseBatchData.data.course) || exam.course || [];
        const batches = courseBatchData.batch || (courseBatchData.exam && courseBatchData.exam.batch) || (courseBatchData.data && courseBatchData.data.batch) || exam.batch || [];

        const subjectNames = exam.subjects
          .map((sub) => sub.subject_name)
          .join(", ");
        setQuestionsCount(exam.question_count);
        setExamTemplate(exam.exam_template);
        setExamDetails({
          examName: exam.exam_name,
          courseName: courses.map((c) => c?.course_name).join(", "),
          batchName: batches.map((c) => c?.batch_name).join(", "),
          subjectNames: subjectNames,
          examImage: exam.image_url,
          questionMarkSystem: exam.question_mark_system,
          perQuestionMark: exam.per_question_mark,
          negativeMarking: exam.negative_marking,
          negativeMarkingScore: exam.negative_marking_score,
          examTemplate: exam.exam_template,
        });
      } catch (error) {
        console.error("Error fetching exam data: ", error);
      }
    };

    fetchExamData();
  }, [rowId, decryptedToken]);

  const Heading = [
    {
      id: 1,
      logo: examDetails.examImage,
      path: "/admin/exam",
      headings: [
        {
          id: 11,
          label: "Name",
          content: examDetails.examName,
        },
        {
          id: 13,
          label: "Course",
          content: examDetails.courseName,
        },
        {
          id: 14,
          label: "Batch",
          content: examDetails.batchName,
        },
      ],
    },
  ];

  const items = [
    { id: 1, label: "Questions List" },
    { id: 2, label: "Add Single Question" },
  ];

  const items1 = [
    {
      id: 1,
      label: (
        <QuestionList
          changeTab={EditchangeTab}
          setQuestionsLength={setQuestionsLength}
          setLoading={setLoading}
        />
      ),
    },
    {
      id: 2,
      label: (
        <AddCenterFeedBackSingle
          changeTab={changeTab}
          examDetails={examDetails}
          examTemplate={examTemplate}
          questionsLength={questionsLength}
        />
      ),
    },
    {
      id: 3,
      label: (
        <EditSingle
          questionId={editQuestion?.questionId}
          examId={editQuestion?.examId}
          fetchData={editQuestion?.fetchData}
          rowId={editQuestion?.rowId}
          examDetails={examDetails}
          examTemplate={examTemplate}
          changeTab={changeTab}
        />
      ),
    },
  ];

  return (
    <div className={`${classes.p2} ${classes.pb0}`}>
      <ToastContainer />
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <CircularProgress style={{ color: "white" }} />
        </div>
      )}
      <QuestionHead Heading={Heading} />

      <div className={classesLocal.root}>
        <AppBar position="static">
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="none"
            aria-label="center feedback tabs"
          >
            {items.map((item) => (
              <CustomTab
                className={classesLocal.tab}
                key={item.id}
                label={item.label}
                id={item.id}
                index={item.id - 1}
                onChange={handleChange}
                {...a11yProps(item.id)}
              />
            ))}
            <div className={`${classesLocal.deletebtn}`}>
              <Button
                className={`${classesLocal.custombtnblue}`}
                onClick={() => setOpenDelete(true)}
              >
                Delete all QP
              </Button>
            </div>
          </Tabs>
        </AppBar>

        {items1.map((item, index) => (
          <CustomTabPanel key={item.id} value={value} index={index} id={item.id}>
            {item.label}
          </CustomTabPanel>
        ))}

        <Modal open={openDelete} onClose={() => setOpenDelete(false)}>
          {IsDelete ? (
            <div style={modalStyle2}>
              <Typography
                variant="h6"
                style={{ marginBottom: "20px", textAlign: "center" }}
              >
                Enter Your Password
              </Typography>
              <TextField
                fullWidth
                type={showPassword ? "text" : "password"}
                variant="outlined"
                required
                placeholder="********"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleToggleShowPassword} edge="end">
                        {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <div style={buttonContainerStyle}>
                <Button
                  onClick={() => {
                    setOpenDelete(false);
                    setIsDelete(false);
                  }}
                  variant="outlined"
                  style={{ marginRight: "10px" }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleStatus}
                  variant="contained"
                  color="primary"
                >
                  submit
                </Button>
              </div>
            </div>
          ) : (
            <div style={modalStyle2}>
              <Typography
                variant="h6"
                style={{ marginBottom: "20px", textAlign: "center" }}
              >
                Are you confirm to delete all questions ?
              </Typography>

              <div style={buttonContainerStyle}>
                <Button
                  onClick={() => setOpenDelete(false)}
                  variant="outlined"
                  style={{ marginRight: "10px" }}
                >
                  No
                </Button>
                <Button
                  onClick={() => setIsDelete(true)}
                  variant="contained"
                  color="primary"
                >
                  Yes
                </Button>
              </div>
            </div>
          )}
        </Modal>
      </div>
    </div>
  );
}

export default AddCenterFeedBackQuestionMain;
